export default "__VITE_ASSET__rr3opAQQ__"